import { SessionKey_FE } from '@nu-art/user-account-frontend';
export const SessionKey_Permissions_FE = new SessionKey_FE('permissions');
export const SessionKey_StrictMode_FE = new SessionKey_FE('strictMode');
//# sourceMappingURL=consts.js.map